import prefixNamespace from '@/utils/prefix-namespace'
import { storeKeyNameSpace } from '@/constants/stores'
import i18n from '@/i18n'
export const _types = {
    getters: {
        GET_OVER_VIEW: 'getOverview',
        GET_SETTINGS_THEME: 'getSettingsTheme',
        GET_AUTO_SETTINGS: 'getAutoSettings',
        GET_OPTIMIZE_PROCESS: 'getOptimizeProcess',
        GET_NEW_OPTIMIZE: 'getNewOptimize'
    },
    actions: {
        OPTIMIZE: 'optimize',
        GET_DETAIL_IMAGE: 'getDetailImage',
        RESTORE_IMAGE: 'restoreImage',
        GET_TOTAL_IMAGES: 'getTotalImages',
        GET_ALL_LOGS: 'getAllLogs',
        GET_OVER_VIEW: 'getOverview',
        START_OPTIMIZE: 'startOptimize',
        GET_LOG_DETAIL: 'getLogDetail',
        GET_COMPRESS_IMAGES_BY_LOG: 'getImgsCompressedByLog',
        HIDE_CONFIRM_RESTORE: 'hideConfirmRestore',
        STOP_OPTIMIZE_IMAGES: 'stopOptimizeImages',
        CHECK_NEW_OPTIMIZE: 'checkNewOptimize',
        GET_SETTINGS_THEME: 'getSettingsTheme',
        GET_PROCESS: 'getProcess',
        STOP_OPTIMIZE_THEME: 'stopOptimizeTheme',
        GET_THEME_BY_LOG: 'getThemeByLog',
        GET_AUTO_SETTINGS: 'getAutoSettings',
        SAVE_AUTO_SETTINGS: 'saveAutoSettings',
        REMOVE_DUPLICATE_THEME: 'removeDuplicateTheme',
        PUBLISH_CHANGE: 'publishChange',
        REMOVE_CODE: 'removeCode',
        UPDATE_TOOLTIP: 'updateTooltip'
    },
    mutations: {
        SET_OVER_VIEW: 'setOverview',
        SET_SETTINGS_THEME: 'setSettingsTheme',
        SET_AUTO_SETTINGS: 'setAutoSettings',
        SET_OPTIMIZE_PROCESS: 'setOptimizeProcess',
        SET_NEW_OPTIMIZE: 'setNewOptimize'
    }
}

export const types = prefixNamespace(`${storeKeyNameSpace.OPTIMIZE_IMAGE}/`, _types)

export const status = [{
    value: "compressed",
    title: "Optimized",
},
{
    value: "restored",
    title: "Restored",
},
{
    value: "already_compressed",
    title: "Already optimal",
}]
export const type = [{
    value: "product",
    title: "Product",
},
{
    value: "collection",
    title: "Collection",
},
{
    value: "article",
    title: "Article",
},
{
    value: "asset",
    title: "Asset",
}]

export const imageColumns = [{
    title: i18n.t('app.columns.image'),
    dataIndex: "src",
    key: "src",
    scopedSlots: {
        customRender: "image",
    },
    width: 100,
},
{
    title: "",
    dataIndex: "title",
    key: "title",
    scopedSlots: {
        customRender: "name",
    },
    width: "25%",
},
{
    title: i18n.t('app.columns.type'),
    dataIndex: "type",
    key: "type",
    scopedSlots: {
        customRender: "type",
    },
    width: "150px",
},
{
    title: i18n.t('app.columns.status'),
    dataIndex: "status",
    key: "status",
    scopedSlots: {
        customRender: "status",
    },
    width: "200px",
},
{
    title: i18n.t('app.columns.original_size'),
    dataIndex: "old_size",
    key: "old_size",
    scopedSlots: {
        customRender: "old_size",
    },
    width: "150px",
    className: "images__original-size"
},
{
    title: i18n.t('app.columns.optimized_size'),
    dataIndex: "size",
    key: "size",
    scopedSlots: {
        customRender: "size",
    },
    width: "150px",
    className: "images__optimized-size"
},
{
    key: "action",
    slots: {
        title: "titleAction",
    },
    scopedSlots: {
        customRender: "action",
    }
}]
export const themeColumns = [{
    title: i18n.t('app.columns.method'),
    dataIndex: "type",
    scopedSlots: {
        customRender: "type",
    },
    width: '55%'
},
{
    title: i18n.t('app.columns.files'),
    dataIndex: "files",
    scopedSlots: {
        customRender: "files",
    },
    width: '20%',
    className: "theme__files"
},
{
    title: i18n.t('app.columns.savings'),
    scopedSlots: {
        customRender: "savings",
    },
    className: "theme__optimized-size"
}]